import { render } from "./PointList_admin.vue?vue&type=template&id=07777392"
import script from "./PointList_admin.vue?vue&type=script&lang=js"
export * from "./PointList_admin.vue?vue&type=script&lang=js"

import "./PointList_admin.vue?vue&type=style&index=0&id=07777392&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__